<template>
  <myhead :value="value" @next="next" @lookmore="more">{{
    $route.query.title || $route.meta.title
  }}</myhead>
  <div class="forum">
    <van-tabs
    v-model:active="active"
    :swipe-threshold="4"
    color="#3F7C93"
    title-active-color="#3F7C93"
    title-inactive-color="#666666"
    
  >
    <van-tab title="我的提问"><Ask :key="$store.state.forumKey"></Ask></van-tab>
    <van-tab title="论坛投票"><Vote :key="$store.state.forumKey"></Vote></van-tab>
    <van-tab title="我的讨论"><Discuss :key="$store.state.forumKey"></Discuss></van-tab>
    <van-tab title="我的预约"><Subscribe :key="$store.state.forumKey"></Subscribe></van-tab>
    <van-tab title="调研投票"><Survey :key="$store.state.forumKey"></Survey></van-tab>
  </van-tabs>
  </div>
</template>
<script>
export default {
  name: 'MyForum'
}
</script>
<script setup>
import { ref,onMounted } from "vue";
import { useRoute } from "vue-router";
import Ask from "./components/forum/Ask.vue";
import Vote from "./components/forum/Vote.vue";
import Discuss from "./components/forum/Discuss.vue";
import Subscribe from "./components/forum/Subscribe.vue";
import Survey from "./components/forum/Survey.vue";
// import {nextFn} from "@/utils/type.js";
//右箭头
const active = ref(0)
const next = () => {
    if(history.forward) {
      history.forward()
    }
}
const route = useRoute()

onMounted(() => {
  if (route.query.id) {
    active.value = parseInt(route.query.id);
  }
});



</script>